import {z as zod} from "zod";

export type OttopilotWebhooksWorkspaceCapabilityConfiguration = Record<string, never>;

export const ottopilotWebhooksWorkspaceCapabilityConfigurationValidator: zod.ZodType<OttopilotWebhooksWorkspaceCapabilityConfiguration> = zod.strictObject({});
